<template>
    <button
        class="cz3__action-button"
        @click.prevent="click"
        :disabled="disabled"
    >
        <span>{{label}}</span>
    </button>
</template>

<style lang="scss">
    @import "../../style/variables.scss";

    #cz2.cz2 {
        .cz3__action-button {
            display: flex;
            justify-content: center;
            align-items: center;

            height: 49px;
            border-radius: 8px;

            border: none;
            background: #000;

            span {
                font-family: $font-main;
                font-weight: 700;
                font-size: 14px;

                color: #fff;
            }

            &:disabled {
                background: #d2d2d2;

                span {
                    color: #a0a0a0;
                }
            }

            &:focus {
                outline: 2px solid #000;
                outline-offset: 2px;
            }
        }
    }
</style>

<script>
    export default {
        props: {
            label: String,
            disabled: Boolean,
        },

        methods: {
            click() {
                this.$emit('click');
            },
        },
    };
</script>
